// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { RapidReviewDiagnosisCodeResponse } from './rapid-review-diagnosis-code-response';

/** See com.rev360.pms.api.controller.encounter.rapidreview.RapidReviewPerformedServiceResponse */
/* istanbul ignore next */
@GandalfModel
export class RapidReviewPerformedServiceResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	code!: string;

	@GandalfProperty({ designType: String })
	description!: string | null;

	@GandalfArray(RapidReviewDiagnosisCodeResponse)
	diagnoses!: RapidReviewDiagnosisCodeResponse[];

	@GandalfProperty({ designType: Number })
	performedServiceId!: number;

}
